import '../../vendor/jquery.vimeo.api'
import '../../vendor/player'

export default {
    init() {
        /* Script for sequencing the video */
        if ($(".module-legend-video")[0]) {
            $(".module-legend-video").each(function () {

                const videoContent = $(this);

                videoContent.find(".video-item").on("click", function () {
                    const index = $(".video-item").index(this);

                    videoContent.find(".video-circle").css("visibility", "hidden");

                    $(this).find(".video-circle").css("visibility", "visible");
                    videoContent.find(".slides-item").removeClass("active");
                    videoContent.find(".slides-item").eq(index).addClass("active");
                });


                videoContent.find('.slides-item.active').on("click", function () {
                    const iframe = $(this).find('iframe')[0];
                    const videoContentPlayer = new Vimeo.Player(iframe);

                    $(this).toggleClass("played");

                    if ($(this).hasClass("played")) {
                        videoContentPlayer.play();

                    } else {
                        videoContentPlayer.pause();
                    }
                })

                // SvideoContent.find('.video-slider').contents().appendTo(videoContent.find('.video-slider-wrapper'));
            });
        }
    }
}